import React from 'react';
import TextField from '@material-ui/core/TextField';
import CheckBox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Radio, RadioGroup, FormControlLabel} from '@material-ui/core';
import moment from 'moment';

const Input = (props) => {

    let inputElement = null;
    let today = moment()

    switch (props.elementType) {
        case ('input'):
            inputElement = <TextField
                {...props.elementConfig}
                value={props.value}
                fullWidth
                variant={props.variant || 'filled'}
                onChange={props.changed}
            />
            break;
        case ('textfield'):
            inputElement = <TextField
                {...props.elementConfig}
                value={props.value}
                fullWidth
                variant={props.variant || 'filled'}
                onChange={props.changed}
                multiline
                rows={4}
            />
            break;
        case ('checkbox'):
            inputElement = <CheckBox
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed}
            />
            break;
        case ('select'):
            inputElement =
                <Select
                    {...props.elementConfig}
                    value={props.value}
                    onChange={props.changed}
                >
                    {props.elementConfig.menuitems.map((item, index) => { 
                        return (
                            <MenuItem 
                            disabled={
                                item === 'AM' &&
                                moment(props.deliverDateValue).format('YYYY-MM-DD') === moment(today).format('YYYY-MM-DD') &&
                                moment(today).format('HH') > moment('12', 'HH').format('HH')
                            } 
                            key={index} 
                            value={item}
                            >
                                {item}
                            </MenuItem> 
                        )
                    })}
                </Select>
            break;
        case ('radio'):
            inputElement = <div>
                <RadioGroup value={props.elementConfig.value}>
                {props.elementConfig.options.map((option, index) => {
                    return (
                        <FormControlLabel key={index} value={option.value} control={<Radio />} label={option.label} />                
                    )
                })}
                </RadioGroup>
            </div>
            break;
        default:
            inputElement = <TextField
                {...props.elementConfig}
                value={props.value}
                fullWidth
                variant={props.variant || 'filled'}
                onChange={props.changed}
            />
    }

    return (
        <div>
            <label>{props.label}</label>
            {inputElement}
        </div>
    )
};

export default Input;